import { type ChatbotMessage, MessageRole } from '../types/messageTypes'

export const getHumanMessagesCount = (
	chatbotMessages: ChatbotMessage[]
): number =>
	chatbotMessages.reduce(
		(acc, chatHistoryMessage) =>
			chatHistoryMessage.role === MessageRole.Human ? acc + 1 : acc,
		1
	)
